export enum ReservationItemTypes {
    Tariff = "Tariff",
    Bundle = "Bundle",
    PersonalLesson = "PersonalLesson",
    RewritableTariff = "RewritableTariff",
    GroupLesson = "GroupLesson",
    BundleLesson = "BundleLesson",
    MarketBill = "MarketBill",
    NewClubContract = "NewClubContract",
    ContractAdditionalService = "ContractAdditionalService",
    AccountReplenishment = "AccountReplenishment",
    SyntechParking = "SyntechParking",
    ContractAdditionalPackage = "ContractAdditionalPackage",
}